/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Computacao() {
  return (
    <PaginasEspecificas posicao="19" endereco="/fisica" materia="Física" />
  );
}

export default Computacao;
